import { Component } from '@angular/core';

@Component({
  selector: 'app-return-and-refund-policy',
  templateUrl: './return-and-refund-policy.component.html',
  styleUrls: ['./return-and-refund-policy.component.css']
})
export class ReturnAndRefundPolicyComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

}
